import defaultApi from '@/utils/request';

export default {
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_studentResTreatRecord/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      url: 's7x_StudentResTreatRecord/Add',
      method: 'post',
      // headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
  Update(data) {
    return defaultApi({
      url: 's7x_StudentResTreatRecord/Update',
      method: 'post',
      data,
    });
  },
};
